// import { useTranslation } from 'react-i18next';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';
import { logger } from '@/utils/logger';
import { useEffect, useRef } from 'react';

export function useI18nNavigate() {
  logger.info("hooks: useI18nNavigate");
  const navigate = useNavigate();
  const location = useLocation();
  const change = useRef(false);

  // const { i18n } = useTranslation();

  useEffect(() => {
    change.current = true;
  }, [location]);

  const wait = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (change.current) {
          resolve(true);
        } else {
          resolve(wait());
        }
      }, 10);
    });
  }

  return async (to: string, options?: NavigateOptions) => {
    logger.info("hooks: useI18nNavigate navigate");
    // const url = to.startsWith("http")
    //     ? new URL(to)
    //     : new URL(to, "http://localhost");
    //     url.pathname = url.pathname +  `${i18n.language === "en" ? "" : `${i18n.language}/`}`;
    // navigate(url.toString().replace("http://localhost", ""), options);
    change.current = false;
    navigate(to, options)
    await wait();
  };
}
